<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from '../Member/Header.svelte';
    import HeaderThemes from '../Member/HeaderThemes.svelte';
    import Footer from '../Member/Footer.svelte';
    import FooterThemes from '../Member/Footerthemes.svelte';
    
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCopy,faStroopwafel,faHandHoldingDollar,faUser,faUserFriends,faLink,faDollarSign } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'
    import Time from "svelte-time";


    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = true
    let textLoding = "กรุณารอสักครู่"
    let textError = ""
    let errotCall = false

    let balance = 0.00
    let acc_name =""
    let creditwd = 0

    let affdata

    async function getAffiliate() {
        loading = true
        const res = await fetch(window.localStorage.getItem("apiurl")+"affiliate/getaffiliate", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            affdata = json.payload
            balance = json.payload.member.wallet
            creditwd = json.payload.member.wallet

            loading = false
            setTimeout(function(){
                
            },100)
            
		} 
        else if(json.statusCode==201){
            textLoding = "กำลังสมัครสมาชิก"
            createmember()
        }else {
            errotCall = true
            textError = json.message
            loading = false
            throw new Error(json);
		}
    }
    async function createmember() {

        const res = await fetch(window.localStorage.getItem("apiurl")+"affiliate/createmember", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            textLoding = "กรุณารอสักครู่"
            getAffiliate()
            
		}else {
            errotCall = true
            textError = json.message
            loading = false
            throw new Error(json);
		}
    }
    
    async function saveAffwithdraw() {
        let isnum = /^\d+$/.test(creditwd);
        if(creditwd==0 || creditwd==undefined || creditwd=='' || isnum==false){
            Swal.fire(`กรุณาตรวจสอบจำนวนเงินที่ต้องการถอน`);
            return false;
        }
        if(Number(balance)<parseInt(creditwd.toString())){
            Swal.fire({
                heightAuto: false,
                title: 'ยอดเงินของคุณไม่เพียงพอ!',
                text: 'ยอดเงิน : '+balance,
                icon: 'error',
                confirmButtonText: 'OK' 
            })
            return
        }

        loading = true
        const res = await fetch(window.localStorage.getItem("apiurl")+"affiliate/savewithdraw", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                credit:parseInt(creditwd.toString())
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            Swal.fire({
                heightAuto: false,
                title: 'ทำรายการสำเร็จ',
                text: '',
                icon: 'success',
                confirmButtonText: 'OK' 
            })
            setTimeout(function(){
                push('/affiliate/history')
            },1000)
		} else {
            Swal.fire({
                    heightAuto: false,
                    title: 'ไม่สามารถทำรายการได้!',
                    text: json.message,
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
            loading = false
            throw new Error(json);
		}
    }
    let promise
    
    $: {
        promise = getAffiliate()
    }
    async function numberonly(evt){
        var e = evt;
        if(window.event){ // IE
            var charCode = e.keyCode;
            if (((charCode < 48) || (charCode > 57)) && (charCode != 13) && (charCode != 8) && charCode != 46) window.event.returnValue = false;
        } else if (e.which) { // Safari 4, Firefox 3.0.4
            var charCode = e.which
            if (((charCode < 48) || (charCode > 57)) && (charCode != 13) && (charCode != 8) && charCode != 46) charCode = e.preventDefault();
        }
    }
</script>
<div class="default-home">
<div class="row pt-2 mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; background-repeat: no-repeat; background-position: center top;">
    <Header />
    
   
    <div class="col-12 text-center mt-3" ><h4 style="background: linear-gradient(135deg, rgb(0 0 0) 0%, rgb(86 80 80) 50%, rgb(131 120 120) 51%, rgb(54 50 50) 71%, rgb(0 0 0) 100%);
        box-shadow: 5px 5px 10px #000 !important;
        line-height: 30px;
        border-radius: 5px;
        padding: 2px 7px;color:gold;">แนะนำเพื่อน</h4></div>
    {#if !errotCall}
    {:else}
    <div class="col-12 text-center mt-3 mb-2 ">
        <div class=" bg-dk p-2 rounded">
            <div class="border border-1 border-danger rounded p-2 text-center mb-2"><span class="text-white">{textError}</span></div>
        </div>
    </div>
    {/if}
    <div class="col-12 " style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/><br />
            <h5 class="text-warning">{textLoding}</h5>
        </div>
        {/if}
        {#if !loading}

        <div class="card mt-0 bg-black">
            <div class="card-body  pb-2">
                <Fa icon={faStroopwafel} size="lg"  spin class={"text-white"} /> <span class={"text-white"}>รายการสรุป</span>
                <div class="row mt-3">
                    <div class="col-4 text-center text-warning">
                        <span>กระเป๋าเงิน</span>
                        <Fa icon={faHandHoldingDollar} size="3x" />
                        <h6 class="mt-2">{affdata.member.wallet}</h6>
                    </div>
                    <div class="col-4 text-center text-warning" style="cursor: pointer;" on:click={() => push('/affiliate/downline')}>
                        <span>Downline</span>
                        <Fa icon={faUser} size="3x" />
                        <h6 class="mt-2">{affdata.downline}</h6>
                    </div>
                    <div class="col-4 text-center text-warning" style="cursor: pointer;" on:click={() => push('/affiliate/downline')}>
                        <span>สมาชิก</span><br />
                        <Fa icon={faUserFriends} size="3x" />
                        <h6 class="mt-2">{affdata.members}</h6>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mt-2 bg-black">
            <div class="card-body  pb-3">
                <Fa icon={faLink} size="lg"  pulse class={"text-warning"}/> <span class={"text-warning"}>ลิ้งค์แนะนำเพื่อน</span>
                <div class="card mt-2 border border-1 border-warning">
                    <div class="card-body rounded p-2 " style="background-color: black;">
                        <h6 class="text-white m-0">{dataSetting.member_url}/#/a/{affdata.member.aff_ref} <Clipboard
                            text= {dataSetting.member_url}/#/a/{affdata.member.aff_ref}
                            let:copy
                            on:copy={() => {
                                Swal.fire(`คัดลอกแล้ว`)
                            }}>
                            <span class="pointer" on:click={copy}><Fa icon={faCopy} size="1.2x"  class="text-info " /></span>
                            </Clipboard></h6>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="card mt-2 bg-black">
            <div class="card-body  pb-3">
                <Fa icon={faHandHoldingDollar} size="lg"  class={"text-warning"}/> <span class={"text-warning"}>ถอนเงิน</span>
                <div class="mb-3 mt-2">
                    <label for="creditwd" class="form-label text-white">กรอกจำนวนที่ต้องการถอน</label>
                    <input type="text" class="form-control rounded-pill text-center" id="creditwd" placeholder="" bind:value={creditwd} on:keypress={()=>numberonly(event)}>
                </div>
                <div class="row">
                    <div class="col-12 text-center d-grid gap-2">
                        <button type="button" class="btn btn-dark rounded-pill btn-gd"  on:click={() => saveAffwithdraw()}>ยืนยันถอน</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 text-center mt-2 mb-2 ">
            <div class=" bg-dk p-2 rounded">
                <!-- <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2" on:click={() => push('/affiliate')}>สรุป</button> -->
                <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2" on:click={() => push('/affiliate/downline')}>รายงานลำดับชั้น</button>
                <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2" on:click={() => push('/affiliate/report')}>รายงานรายได้</button>
                <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2" on:click={() => push('/affiliate/history')}>รายการถอนเงิน</button>
            </div>
            
        </div>
        <div class="card mt-2 mb-5 bg-black">
            <div class="card-body  pb-3 text-white">
                <Fa icon={faDollarSign} size="lg"  class={"text-warning"}/> <span class={"text-warning"}>รายละเอียดรายได้</span>
                <div class="d-flex justify-content-between mt-3">
                    <div class="d-flex">กลุ่มรายได้</div>
                    <div class="d-flex">{affdata.group.group_name}</div>
                </div>
                <div class="d-flex justify-content-between">
                    <div class="d-flex">รับรายได้ล่าสุด</div>
                    <div class="d-flex">
                        {#if affdata.member.last_withdraw_dtm>0}
                        <Time timestamp="{affdata.member.last_withdraw_dtm*1000}" format="DD/MM/YYYY" />
                        {:else}
                        -
                        {/if}
                    </div>
                </div>
                <div class="d-flex justify-content-between">
                    <div class="d-flex">ยอดรับรายได้ล่าสุด</div>
                    <div class="d-flex">{affdata.member.last_withdraw}</div>
                </div>
                <div class="d-flex justify-content-between">
                    <div class="d-flex">ประเภท</div>
                    <div class="d-flex">
                        {#if affdata.group.aff_type=='P'}
                            รับจากยอดกำไร(ฝาก-ถอน)
                        {/if}
                        {#if affdata.group.aff_type=='A'}
                            รับจากยอดฝาก
                        {/if}
                        {#if affdata.group.aff_type=='F'}
                            รับจากยอดฝากแรก
                        {/if}
                        {#if affdata.group.aff_type=='T'}
                            รับจากยอดเทิร์นโอเวอร์
                        {/if}
                        {#if affdata.group.aff_type=='W'}
                            รับจากยอดได้เสีย
                        {/if}
                    </div>
                </div>
                <div class="d-flex justify-content-between">
                    <div class="d-flex">ผลตอบแทน</div>
                    <div class="d-flex">{affdata.group.profit}</div>
                </div>
                <div class="d-flex justify-content-between">
                    <div class="d-flex">ประผลตอบแทน</div>
                    <div class="d-flex">
                        {#if affdata.group.profit_type=='P'}
                            เปอร์เซ็น
                        {/if}
                        {#if affdata.group.profit_type=='B'}
                            บาท
                        {/if}
                    </div>
                </div>
            </div>
        </div>
       
        {/if}
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-affs">
        <HeaderThemes/>
        <div class="col-12 text-center" ><h4 class="head-title">แนะนำเพื่อน</h4></div>
        {#if !errotCall}
        {:else}
        <div class="col-12 text-center mt-3 mb-2 ">
            <div class=" bg-dk p-2 rounded">
                <div class="border border-1 border-danger rounded p-2 text-center mb-2"><span class="text-white">{textError}</span></div>
            </div>
        </div>
        {/if}
        <div class="col-12 " style="min-height: 500px;">
            {#if loading}
            <div class="text-center mt-2" style="">
                <Fa icon={faSpinner} size="3x" pulse class="text-white"/><br />
                <h5 class="text-warning">{textLoding}</h5>
            </div>
            {/if}
            {#if !loading}
    
            <div class="card mt-0 bg-black">
                <div class="card-body  pb-2">
                    <Fa icon={faStroopwafel} size="lg"  spin class={"text-warning"} /> <span class={"text-warning"}>รายการสรุป</span>
                    <div class="row mt-3">
                        <div class="col-4 text-center text-white">
                            <span>กระเป๋าเงิน</span>
                            <Fa icon={faHandHoldingDollar} size="3x" />
                            <h6 class="mt-2">{affdata.member.wallet}</h6>
                        </div>
                        <div class="col-4 text-center text-white" style="cursor: pointer;" on:click={() => push('/affiliate/downline')}>
                            <span>Downline</span>
                            <Fa icon={faUser} size="3x" />
                            <h6 class="mt-2">{affdata.downline}</h6>
                        </div>
                        <div class="col-4 text-center text-white" style="cursor: pointer;" on:click={() => push('/affiliate/downline')}>
                            <span>สมาชิก</span><br />
                            <Fa icon={faUserFriends} size="3x" />
                            <h6 class="mt-2">{affdata.members}</h6>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="card mt-2 bg-black">
                <div class="card-body  pb-3">
                    <Fa icon={faLink} size="lg"  pulse class={"text-warning"}/> <span class={"text-warning"}>ลิ้งค์แนะนำเพื่อน</span>
                    <div class="mt-2 border border-1 border-warning  mini-blog">
                        <div class="card-body rounded p-2">
                            <h6 class="text-white m-0 aff-text">{dataSetting.member_url}/#/a/{affdata.member.aff_ref} <Clipboard
                                text= {dataSetting.member_url}/#/a/{affdata.member.aff_ref}
                                let:copy
                                on:copy={() => {
                                    Swal.fire(`คัดลอกแล้ว`)
                                }}>
                                <span class="pointer" on:click={copy}><Fa icon={faCopy} size="1.2x"  class="text-info " /></span>
                                </Clipboard></h6>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="card mt-2 bg-black">
                <div class="card-body  pb-3">
                    <Fa icon={faHandHoldingDollar} size="lg"  class={"text-warning"}/> <span class={"text-warning"}>ถอนเงิน</span>
                    <div class="mb-3 mt-2">
                        <label for="creditwd" class="form-label text-white">กรอกจำนวนที่ต้องการถอน</label>
                        <input type="text" class="form-control rounded-pill text-center" id="creditwd" placeholder="" bind:value={creditwd} on:keypress={()=>numberonly(event)}>
                    </div>
                    <div class="row">
                        <div class="col-12 text-center d-grid gap-2">
                            <button type="button" class="btn btn-dark rounded-pill btn-gd"  on:click={() => saveAffwithdraw()}>ยืนยันถอน</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center mt-2 mb-2 ">
                <div class=" bg-dk p-2 rounded">
                    <!-- <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2" on:click={() => push('/affiliate')}>สรุป</button> -->
                    <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2 btn-affs" on:click={() => push('/affiliate/downline')}>รายงานลำดับชั้น</button>
                    <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2 btn-affs" on:click={() => push('/affiliate/report')}>รายงานรายได้</button>
                    <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2 btn-affs" on:click={() => push('/affiliate/history')}>รายการถอนเงิน</button>
                </div>
                
            </div>
            <div class="card mt-2 mb-5 bg-black">
                <div class="card-body  pb-3 text-white">
                    <Fa icon={faDollarSign} size="lg"  class={"text-warning"}/> <span class={"text-warning"}>รายละเอียดรายได้</span>
                    <div class="d-flex justify-content-between mt-3">
                        <div class="d-flex">กลุ่มรายได้</div>
                        <div class="d-flex">{affdata.group.group_name}</div>
                    </div>
                    <div class="d-flex justify-content-between">
                        <div class="d-flex">รับรายได้ล่าสุด</div>
                        <div class="d-flex">
                            {#if affdata.member.last_withdraw_dtm>0}
                            <Time timestamp="{affdata.member.last_withdraw_dtm*1000}" format="DD/MM/YYYY" />
                            {:else}
                            -
                            {/if}
                        </div>
                    </div>
                    <div class="d-flex justify-content-between">
                        <div class="d-flex">ยอดรับรายได้ล่าสุด</div>
                        <div class="d-flex">{affdata.member.last_withdraw}</div>
                    </div>
                    <div class="d-flex justify-content-between">
                        <div class="d-flex">ประเภท</div>
                        <div class="d-flex">
                            {#if affdata.group.aff_type=='P'}
                                รับจากยอดกำไร(ฝาก-ถอน)
                            {/if}
                            {#if affdata.group.aff_type=='A'}
                                รับจากยอดฝาก
                            {/if}
                            {#if affdata.group.aff_type=='F'}
                                รับจากยอดฝากแรก
                            {/if}
                            {#if affdata.group.aff_type=='T'}
                                รับจากยอดเทิร์นโอเวอร์
                            {/if}
                            {#if affdata.group.aff_type=='W'}
                                รับจากยอดได้เสีย
                            {/if}
                        </div>
                    </div>
                    <div class="d-flex justify-content-between">
                        <div class="d-flex">ผลตอบแทน</div>
                        <div class="d-flex">{affdata.group.profit}</div>
                    </div>
                    <div class="d-flex justify-content-between">
                        <div class="d-flex">ประผลตอบแทน</div>
                        <div class="d-flex">
                            {#if affdata.group.profit_type=='P'}
                                เปอร์เซ็น
                            {/if}
                            {#if affdata.group.profit_type=='B'}
                                บาท
                            {/if}
                        </div>
                    </div>
                </div>
            </div>
           
            {/if}
        </div>
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">
    
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd2{
        --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.7rem;
        font-weight: 300;
    }
    .btn-gd{
        /* --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300; */
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
    .bg-black{
        background: #000000ad !important;
    }
</style>